import { useConnection } from "wagmi";

/**
 * Get connected wallet address, connection status, and utilities
 */
const useWalletAuth = () => {
  const { address, connector, isConnected } = useConnection();

  return { address, connector, isConnected };
};

export { useWalletAuth };
